export const GET_REQUEST = "GET_REQUEST";

export const ACCEPT_REQUEST = "ACCEPT_REQUEST";
